<template>
  <div>
    <v-row>
      <v-col cols="12" md="6">
        <v-card outlined>
          <v-card-title class="d-flex justify-center primary--text text-subtitle-2">
            Ranking del estudiante
          </v-card-title>
          <v-card-text>
            <v-row dense>
              <v-col cols="12" class="d-flex justify-space-between">
                <div>
                  <p>Tipo de evaluación</p>
                  <v-radio-group v-model="tipoGraph" @change="getRankingStuBySec()" row>
                    <v-radio label="Evaluaciones" value="EVALUACIONES" />
                    <v-radio label="Somos hábiles" value="SOMOS HÁBILES" />
                    <v-radio label="Simulador" value="SIMULADOR" />
                  </v-radio-group>
                </div>

                <v-card outlined>
                  <v-card-text>
                    <v-row dense class="d-flex text-center">
                      <v-col cols="12" class="d-flex justify-center primary--text">
                        <v-icon color="yellow" left>
                          fas fa-star
                        </v-icon>
                        Ranking de la sección
                      </v-col>
                      <v-col cols="12" class="text-h6">
                        {{ posicionAlumno }}
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12">

                <!-- <v-select v-model="tipoGraph" :items="listTipoGraph" label="Tipo de evaluación" single-line dense
              hide-details outlined small class="my-select" append-icon="mdi-chevron-down"></v-select> -->
                <ComundataTablecomp :headers="HeadersRankeds" :items="rankingAlumnos">
                  <template v-slot:rank_alumno="{ item }">
                    <div>
                      <v-avatar v-if="item.rank_alumno == 1">
                        <v-img src="../../../../../public/first.png"></v-img>
                      </v-avatar>
                      <v-avatar v-else-if="item.rank_alumno == 2">
                        <v-img src="../../../../../public/second.png"></v-img>
                      </v-avatar>
                      <v-avatar v-else-if="item.rank_alumno == 3">
                        <v-img src="../../../../../public/third.png"></v-img>
                      </v-avatar>
                      <div v-else>
                        {{ item.rank_alumno }}
                      </div>
                    </div>
                  </template>

                  <template v-slot:nombre_completo="{ item }">
                    <v-chip small :color="filter.id_alumno == item.id_alumno ? 'primary' : ''">
                      {{ item.nombre_completo }}
                    </v-chip>
                  </template>
                </ComundataTablecomp>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" v-if="tipoGraph !== 'EVALUACIONES'">
        <v-card outlined>
          <v-card-text>
            <v-row dense>
              <v-col cols="12">
                <TradingChart :dataGraph="somosHabilesEst" :intervals="intervals" :currentInterval="currentInterval"
                  @update:currentInterval="currentInterval = $event" :seriesesData="filteredData"></TradingChart>

              </v-col>
            </v-row>
          </v-card-text>
          <v-card-subtitle class="d-flex text-center">
            <span>
              El siguiente gráfico representa el progreso del estudiante y cómo eso influye en su ranking dentro de
              la sección. Además, es un gráfico interactivo donde se puede visualizar cualquier punto de interés y ver
              las
              preguntas y respuestas.
            </span>
          </v-card-subtitle>
          <v-card-subtitle>
            <span>
              <div class="">EJE VERTICAL: Representación de las notas del 1 al 20</div>
              <div class="">EJE HORIZONTAL: Fechas en las que los exámenes fueron rendidos</div>
            </span>
          </v-card-subtitle>
        </v-card>

      </v-col>
      <v-col v-else cols="12" md="6">
        <MetricasEvaluaciones :filter="filter" :change="tipoGraph" ref="metricaPerEval"></MetricasEvaluaciones>
      </v-col>


    </v-row>
  </div>
</template>

<script>
import axios from "@/helpers/axios";
import { HeadersRankeds } from '../../../../helpers/headersTable';


import TradingChart from './TradingViewsExample.vue'
import MetricasEvaluaciones from './MetricaEvaluaciones.vue'
import ComundataTablecomp from '../../../../components/ComponentsEst/ComundataTablecomp.vue';

export default {
  name: 'SomosHabilesChartComp',
  props: ['filter'],
  components: {
    TradingChart,
    ComundataTablecomp,
    MetricasEvaluaciones
  },
  data() {
    return {
      intervals: ['Día', 'Semana', 'Mes', 'Periodo', 'Año'],
      currentInterval: 'Año',
      rankingAlumnos: [],
      somosHabilesEst: [],
      posicionAlumno: "",
      filteredData: new Map(),
      HeadersRankeds,

      additionalDataMap: new Map(),
      tipoGraph: "EVALUACIONES",
      dataStorage: sessionStorage,
      evalGraph: false
    }
  },

  methods: {

    async getRankingStuBySec() {
      this.rankingAlumnos = []
      if (this.tipoGraph == 'EVALUACIONES') {
        try {
          const response = await axios.get("/metricaSomosHabiles/rankingPorSeccion", {
            params: {
              id_an_lect: sessionStorage.id_ano_lectivo,
              id_colegio: sessionStorage.id_colegio,
              id_seccion: this.filter.id_seccion
            }

          })

          this.rankingAlumnos = response.data.data;

          const alumno = this.rankingAlumnos.find(a => a.id_alumno === this.filter.id_alumno);

          if (!alumno) {
            this.posicionAlumno = "0";
            return;
          }

          const totalAlumnos = this.rankingAlumnos.length;
          const rankingAlumno = parseInt(alumno.rank_alumno);

          this.posicionAlumno = rankingAlumno + '/' + totalAlumnos;

        } catch (error) {
          console.error("Error en ranking", error);
        }
      } else {
        try {
          const response = await axios.get("/rankingPorSeccionMet/rankSomosHabiles", {
            params: {
              tipo_eval: this.tipoGraph,
              realizados: true,
              id_an_lect: sessionStorage.id_ano_lectivo,
              id_colegio: sessionStorage.id_colegio,
              id_seccion: this.filter.id_seccion
            }

          })
          this.rankingAlumnos = response.data.data;

          const alumno = this.rankingAlumnos.find(a => a.id_alumno === this.filter.id_alumno);

          if (!alumno) {
            this.posicionAlumno = "0";
            return;
          }

          const totalAlumnos = this.rankingAlumnos.length;
          const rankingAlumno = parseInt(alumno.rank_alumno);

          this.posicionAlumno = rankingAlumno + '/' + totalAlumnos;
          this.lightWeightChart();

        } catch (error) {
          console.error("Error en ranking", error);
        }
      }

    },

    async lightWeightChart() {

      try {
        this.limpiarData();

        const idCurrentPeriodo = sessionStorage.periodos_actuales.split(",")[0]
        let range = "1 year"
        if (this.currentInterval == "Día") range = "Dia"
        if (this.currentInterval == "Semana") range = "Semana"
        if (this.currentInterval == "Mes") range = "Mes"
        if (this.currentInterval == "Periodo") range = "Bimestre"
        if (this.currentInterval == "Año") range = "Año"

        const somosHabEst = await axios.get("/metricaSomosHabiles/", {
          params: {
            id_al: this.filter.id_alumno,
            range,
            id_per: idCurrentPeriodo,
            perfil: sessionStorage.licencia_perfil,
            id_perso: sessionStorage.id_persona,
            tipo_eval: this.tipoGraph
          }
        })
        const noRepeats = somosHabEst.data.data.filter(a=> a.fecha_creacion != "2024-01-31 09:53:46")
        this.somosHabilesEst = noRepeats
        console.log(this.somosHabilesEst, "dataknareas");
        const dataChart = noRepeats.map(obj => {
          let date = new Date(obj.fecha_creacion);
          let utcDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
          let time = Math.floor(utcDate.getTime() / 1000);
          this.additionalDataMap.set(time, {
            codigo: obj.codigo,
            time: time,
            verdaderas: obj.verdaderas,
            cantidad_preguntas: obj.cantidad_preguntas
          })

          return {
            // ...obj,
            time: time,
            value: (20 / obj.cantidad_preguntas) * obj.verdaderas  // antiguo=> obj.verdaderas / obj.cantidad_preguntas
          }
        })
        this.filteredData.set(this.currentInterval, dataChart);
      } catch (error) {
        console.error(error);
      }
    },


    cambiarGrafProgEval(){
      if(this.tipoGraph == "EVALUACIONES") this.evalGraph = true
      else this.evalGraph = false
    },



    updateData(){
      console.log("fas");
      if(this.tipoGraph == 'EVALUACIONES') this.$refs.metricaPerEval.fetchDataFromAPI();
      else this.lightWeightChart();
    },




    limpiarData() {
      this.additionalDataMap.clear();
    }
  },

  watch: {
    currentInterval() {
      this.lightWeightChart()
    },
    // tipoGraph(){
    //   this
    // }
  },

  mounted() {
    this.getRankingStuBySec();
    this.lightWeightChart();
  },
}
</script>

<style scoped>
.my-select .v-select__slot {
  padding-top: 0;
  padding-bottom: 0;
}

.my-select .v-label {
  font-size: 0.875rem;
}

.my-select .v-icon {
  font-size: 18px;
}

.my-select .v-select__selections {
  font-size: 0.875rem;
}
</style>